var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCornerRtl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 115,
  height: 100,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#corner-rtl_svg__a)",
  fillOpacity: 0.4,
  d: "M41.51 42.496h13.3c.6 0 1.1-.4 1.1-1v-19.9C55.91 12.196 60.1 1.5 75 1.5h40v97.996H1.5V80.5c0-20.5 12.11-38.004 40.01-38.004"
})), /*#__PURE__*/React.createElement("mask", {
  id: "corner-rtl_svg__b",
  width: 67,
  height: 70,
  x: 2,
  y: 2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M65 3.5 69 2 17 13.5 2 72l2.5-8.5 2.5-5 4-5 4-3.5 6-4 37.5-36 2-3z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#corner-rtl_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#corner-rtl_svg__c)",
  d: "M.387 2.432h112.967v89.82H.387z",
  opacity: 0.4
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M55.5 21c0-4.382.609-9.03 3.5-13q-.093.123-.202.232c-3.855 3.806-8.276 7.149-11.927 10.694-9.465 9.19-18.479 17.944-28.265 28.534q-.14.151-.308.272c5.8-4.121 13.462-6.173 23.284-6.173h13.353L55.5 40.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#ECEFF1",
  d: "M75 1C59.917 1 55.675 11.31 55.675 20.894V41.07c0 .55-.488.988-1.091.988h-13.52C12.782 42.058 1 60.26 1 81"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "corner-rtl_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-22.48891 -16.244 35.66851 -49.38109 45.887 50.686)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.505,
  stopColor: "#212121"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A5A5A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "corner-rtl_svg__a",
  x1: 36,
  x2: 58,
  y1: 27.5,
  y2: 53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#525D62"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0BEC5",
  stopOpacity: 0
})))));
export { SvgCornerRtl as ReactComponent };
export default "data:image/svg+xml;base64,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";